import { sample } from "lodash";
import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import ContentCenter from "../../ui/ContentCenter";
import GameOverLayer from "../../ui/GameOverLayer";

const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px;
`;

const RowContainer = styled.div`
  display: flex;
`;

const CellContainer = styled.div``;

const LetterCellTarget: any = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  border: 0.5px solid #ccc;

  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: bold;
  transition: background-color ease-in-out 0.2s;

  ${(p: any) =>
    p.active &&
    css`
      background: #ccc !important;
    `}

  ${(p: any) =>
    p.solved &&
    css`
      background: #f2cdce !important;
      border: 0.5px solid #f2cdce;
    `}
`;

const LetterCell = ({ letter }: any) => {
  return <div>{letter}</div>;
};

const Grid = ({ rows, cols, cellRender }: any) => {
  const rowRender = () => {
    const renderRows = [];
    for (let row = 0; row <= rows; row++) {
      const cells = [];
      for (let cell = 0; cell <= cols; cell++) {
        cells.push(cellRender({ row, cell }));
      }

      renderRows.push([...cells]);
    }

    return renderRows;
  };

  return (
    <GridContainer>
      {rowRender().map((row) => {
        return (
          <RowContainer className={"gridRow"}>
            {row.map((cell) => (
              <CellContainer className={"gridCell"}>{cell}</CellContainer>
            ))}
          </RowContainer>
        );
      })}
    </GridContainer>
  );
};

const lowerCaseLetters = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "q",
  "r",
  "s",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];

export default ({ seed, level, disabled, setGameOver }: any) => {
  const [activeLetters, setActiveLetters] = useState<any>([]);
  const [letterGrid, setLetterGrid] = useState<any>([]);
  const [fadeout, setFadeout] = useState(0);
  const [solvedLetters, setSolvedLetters] = useState<any>([]);

  const letters = [
    ...lowerCaseLetters,
    ...lowerCaseLetters.map((letter) => letter.toUpperCase()),
  ];

  const overwrites =
    seed % 2 === 0
      ? [
          {
            cell: 15,
            row: 16,
            group: 1,
            component: <LetterCell group={1} letter={"s"} />,
          },
          {
            cell: 16,
            row: 16,
            group: 1,
            component: <LetterCell group={1} letter={"P"} />,
          },
          {
            cell: 16,
            row: 15,
            group: 1,
            component: <LetterCell group={1} letter={"o"} />,
          },
          {
            cell: 17,
            row: 15,
            group: 1,
            component: <LetterCell group={1} letter={"r"} />,
          },
          {
            cell: 18,
            row: 15,
            group: 1,
            component: <LetterCell group={1} letter={"t"} />,
          },

          // group 2
          {
            cell: 7,
            row: 3,
            group: 2,
            component: <LetterCell group={2} letter={"s"} />,
          },
          {
            cell: 7,
            row: 4,
            group: 2,
            component: <LetterCell group={2} letter={"P"} />,
          },
          {
            cell: 8,
            row: 4,
            group: 2,
            component: <LetterCell group={2} letter={"o"} />,
          },
          {
            cell: 9,
            row: 4,
            group: 2,
            component: <LetterCell group={2} letter={"r"} />,
          },
          {
            cell: 10,
            row: 3,
            group: 2,
            component: <LetterCell group={2} letter={"t"} />,
          },

          // group 3
          {
            cell: 16,
            row: 6,
            group: 3,
            component: <LetterCell group={3} letter={"s"} />,
          },
          {
            cell: 16,
            row: 5,
            group: 3,
            component: <LetterCell group={3} letter={"P"} />,
          },
          {
            cell: 15,
            row: 4,
            group: 3,
            component: <LetterCell group={3} letter={"o"} />,
          },
          {
            cell: 15,
            row: 3,
            group: 3,
            component: <LetterCell group={3} letter={"r"} />,
          },
          {
            cell: 16,
            row: 3,
            group: 3,
            component: <LetterCell group={3} letter={"t"} />,
          },

          // Group 4
          {
            cell: 12,
            row: 9,
            group: 4,
            component: <LetterCell group={4} letter={"s"} />,
          },
          {
            cell: 11,
            row: 9,
            group: 4,
            component: <LetterCell group={4} letter={"P"} />,
          },
          {
            cell: 11,
            row: 8,
            group: 4,
            component: <LetterCell group={4} letter={"o"} />,
          },
          {
            cell: 11,
            row: 7,
            group: 4,
            component: <LetterCell group={4} letter={"r"} />,
          },
          {
            cell: 12,
            row: 7,
            group: 4,
            component: <LetterCell group={4} letter={"t"} />,
          },
        ]
      : [
          {
            cell: 13,
            row: 16,
            group: 1,
            component: <LetterCell group={1} letter={"s"} />,
          },
          {
            cell: 14,
            row: 16,
            group: 1,
            component: <LetterCell group={1} letter={"P"} />,
          },
          {
            cell: 14,
            row: 15,
            group: 1,
            component: <LetterCell group={1} letter={"o"} />,
          },
          {
            cell: 15,
            row: 15,
            group: 1,
            component: <LetterCell group={1} letter={"r"} />,
          },
          {
            cell: 16,
            row: 15,
            group: 1,
            component: <LetterCell group={1} letter={"t"} />,
          },

          // group 2
          {
            cell: 5,
            row: 3,
            group: 2,
            component: <LetterCell group={2} letter={"s"} />,
          },
          {
            cell: 5,
            row: 4,
            group: 2,
            component: <LetterCell group={2} letter={"P"} />,
          },
          {
            cell: 6,
            row: 4,
            group: 2,
            component: <LetterCell group={2} letter={"o"} />,
          },
          {
            cell: 7,
            row: 4,
            group: 2,
            component: <LetterCell group={2} letter={"r"} />,
          },
          {
            cell: 8,
            row: 3,
            group: 2,
            component: <LetterCell group={2} letter={"t"} />,
          },

          // group 3
          {
            cell: 14,
            row: 6,
            group: 3,
            component: <LetterCell group={3} letter={"s"} />,
          },
          {
            cell: 14,
            row: 5,
            group: 3,
            component: <LetterCell group={3} letter={"P"} />,
          },
          {
            cell: 13,
            row: 4,
            group: 3,
            component: <LetterCell group={3} letter={"o"} />,
          },
          {
            cell: 13,
            row: 3,
            group: 3,
            component: <LetterCell group={3} letter={"r"} />,
          },
          {
            cell: 14,
            row: 3,
            group: 3,
            component: <LetterCell group={3} letter={"t"} />,
          },

          // Group 4
          {
            cell: 10,
            row: 9,
            group: 4,
            component: <LetterCell group={4} letter={"s"} />,
          },
          {
            cell: 9,
            row: 9,
            group: 4,
            component: <LetterCell group={4} letter={"P"} />,
          },
          {
            cell: 9,
            row: 8,
            group: 4,
            component: <LetterCell group={4} letter={"o"} />,
          },
          {
            cell: 9,
            row: 7,
            group: 4,
            component: <LetterCell group={4} letter={"r"} />,
          },
          {
            cell: 10,
            row: 7,
            group: 4,
            component: <LetterCell group={4} letter={"t"} />,
          },
        ];

  useEffect(() => {
    let r = 24;
    let c = 24;
    const grid = [];
    for (let i = 0; i < r; i++) {
      const row = [];
      for (let j = 0; j < c; j++) {
        row.push(sample(letters));
      }
      grid.push(row);
    }
    setSolvedLetters([]);
    setActiveLetters([]);
    setLetterGrid(grid);
  }, [seed]);

  const isActive = (n: any) => {
    return activeLetters.find(
      (test: any) => test.cell === n.cell && test.row === n.row
    );
  };

  const isSolved = (n: any) => {
    const groupLetters = overwrites.filter((o: any) => o.group === n.group);
    let solved = true;
    groupLetters.forEach((letter) => {
      solved = solved && isActive(letter);
    });
    return solved;
  };

  const hasFinished = overwrites
    .map((overwrite) => overwrite.group)
    .map((group) => isSolved({ group }))
    .reduce((prev, acc) => prev && acc, true);

  useEffect(() => {
    setGameOver(hasFinished);
  }, [hasFinished])

  const overwriteClick = (overwrite: any) => {
    if (solvedLetters.indexOf(`${overwrite.row},${overwrite.cell}`) === -1)
      setSolvedLetters([...solvedLetters, `${overwrite.row},${overwrite.cell}`]);
    setActiveLetters([...activeLetters, overwrite]);
    setFadeout(fadeout + 1);
  };

  useEffect(() => {
    if (level !== 2) {
      return;
    }

    overwrites
      .map((overwrite) => overwrite.group)
      .filter((group) => isSolved({ group }))
      .forEach((overwrite: any) => {
        setTimeout(() => {
          setActiveLetters(
            activeLetters.filter((f: any) => {
              return f.group !== overwrite;
            })
          );
        }, 1000);
      });
  }, [fadeout]);

  if (!letterGrid.length) {
    return <></>;
  }

  return (
    <ContentCenter style={{ height: "100%" }}>
      {level === 1 && hasFinished || level === 2 && solvedLetters.length === overwrites.length ? (
        <GameOverLayer>
          <strong>GESCHAFFT!</strong>
          <p>
            Klicken Sie auf <strong>Buchstabenanordnung</strong>, um
            das nächste Rätsel zu lösen.
          </p>
          </GameOverLayer>
      ) : (
        <></>
      )}
      <div style={{ opacity: disabled ? "0.5" : hasFinished ? 0.1 : 1 }}>
        <Grid
          rows={16}
          cols={20}
          cellRender={({ row, cell }: any) => {
            const overwrite = overwrites.find(
              (o) => o.row === row && o.cell === cell
            );

            if (overwrite) {
              return (
                <LetterCellTarget
                  active={isActive(overwrite)}
                  solved={isSolved(overwrite)}
                  onClick={() => {
                    overwriteClick(overwrite);
                  }}
                >
                  {overwrite.component}
                </LetterCellTarget>
              );
            }

            return <LetterCellTarget>{letterGrid[row][cell]}</LetterCellTarget>;
          }}
        />
      </div>
    </ContentCenter>
  );
};
